import React from "react";
import { Link } from "react-router-dom";


function HeaderTopContent({ content }) {
  return (
    <div className="header-top-content-wrapper">
      <p>
        <Link to= "/catalog/all/returnable-policy/returnable"> Introducing 5-10 business days delivery and easy returns on a wide range of styles.</Link>
      </p>
    </div>
  );
}

export default HeaderTopContent;